import React, { useRef } from "react";
import "../../assets/styles/Button.scss";
import "../../assets/styles/InputFile.scss";

export interface InputFileProps {
  name: string;
  label: string;
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
}

export interface InputFileState {}

export const InputFile = (props: InputFileProps) => {
  const { name, label, onChange } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <div>
      <input
        type="file"
        name={name}
        id={`inputFile${name}`}
        className="inputfile"
        onChange={onChange}
        ref={inputRef}
      />
      <label className="button pink smaller-text" htmlFor={`inputFile${name}`}>
        {label}
      </label>
    </div>
  );
};

export default InputFile;
